







































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import { BModal, BCarousel } from 'bootstrap-vue';
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  sumup_name: string
  practice_examinee_id: string
  curriculum_id: number
  curriculumResult: any
  fieldResults: any[],
  part1Results: any[],
  sort_part1_asc: boolean
  sort_total_average_asc: boolean
  sort_correct_state_asc: boolean
  previewActive: boolean,
  carouselPageIdx: number
  windowHeight: number
  base64Images: string[]
  isShowCarousel: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sumup_name: null,
      practice_examinee_id: null,
      curriculum_id: null,
      curriculumResult: null,
      fieldResults: [],
      part1Results: [],
      sort_part1_asc: true,
      sort_total_average_asc: true,
      sort_correct_state_asc: true,
      previewActive: false,
      carouselPageIdx: 0,
      windowHeight: 0,
      base64Images: [],
      isShowCarousel: false,
      errors: [],
    });

    /************************************************************
     * 答案画像モーダル表示
     ************************************************************/
    const previewImage = async () => {
      if(state.base64Images.length == 0){
        alert("答案画像が作成されていません。");
        return;
      }
      state.isShowCarousel = true;
      state.carouselPageIdx = 0;
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/
    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.base64Images.length -1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/
    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.base64Images.length){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /************************************************************
     * 画面リサイズ時のウィンドウの高さを保持
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      state.windowHeight = windowHeight;
    };


    const decorate_is_correct = (correct_state: number) => {
      switch (correct_state) {
        case -1:
          return "×"
          break;
        case 1:
          return "○"
          break;
        case 0:
          return "△"
          break;
      }
    };

    // 大問1を並び替え
    const sort_by_part1 = () => {
      if (state.sort_part1_asc) {
        // 昇順
        state.fieldResults.sort(function(a, b) {
          if (a.sort_no <= b.sort_no) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.fieldResults.sort(function(a, b) {
          if (a.sort_no >= b.sort_no) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_part1_asc = !state.sort_part1_asc
    };

    // 全体正答率を並び替え
    const sort_by_total_average = () => {
      if (state.sort_total_average_asc) {
        // 昇順
        state.fieldResults.sort(function(a, b) {
          if (Number(a.score_rate) >= Number(b.score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.fieldResults.sort(function(a, b) {
          if (Number(a.score_rate) <= Number(b.score_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_total_average_asc = !state.sort_total_average_asc
    };

    // 正誤を並び替え
    const sort_by_correct_state = () => {
      if (state.sort_correct_state_asc) {
        // 昇順
        state.fieldResults.sort(function(a, b) {
          if (a.correct_state >= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.fieldResults.sort(function(a, b) {
          if (a.correct_state <= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_correct_state_asc = !state.sort_correct_state_asc
    };

    onMounted(async () => {

      state.practice_examinee_id = context.root.$route.params.practice_examinee_id;
      state.curriculum_id = Number(context.root.$route.params.curriculum_id);

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/practice_examinee/result_detail?practice_examinee_id=${state.practice_examinee_id}&curriculum_id=${state.curriculum_id}`).then(response => {
        state.sumup_name = response.data.sumup_group.name;
        state.curriculumResult = response.data.curriculum_result;
        state.fieldResults = response.data.field_results;
        state.part1Results = response.data.part1_results;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });

      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
    });

    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      decorate_is_correct,
      sort_by_part1,
      sort_by_total_average,
      sort_by_correct_state,
      previewImage,
      carouselPrev,
      carouselNext,
    };
  }
})
